import React from 'react';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router-dom';

const VideoPlayer = () => {

    const { videoUrl } = useParams();
    //THE LINK MUST BE URI ENCODED TO WORK!!!
    const defaultUrl = 'https%3A%2F%2Fstclaycopublicfiles.blob.core.windows.net%2Femployee-benefits%2FNewHireBenefitsVideo%2Fmaster.m3u8';
    const finalUrl = videoUrl ? decodeURIComponent(videoUrl) : decodeURIComponent(defaultUrl);
    
    return (
        <div style={{ position: 'fixed', top: '45px', left: 0, width: '100%', height: 'calc(100% - 45px)', backgroundColor: 'black' }}>
            <ReactPlayer url={finalUrl} controls={true} width='100%' height='100%'/>
        </div>
    );
};

export default VideoPlayer;

// Lock scrolling on this page
//document.body.style.overflow = 'hidden';